<template>
  <form>
    <ui-container>
      <ui-form-section :title="editMode ? 'Update NCR' : 'Add new NCR'" subtitle="Provide the main details of the NCR in this section." class="py-8 border-b">
        <ui-input label="Title" name="title" :error="form.errors.get('title')" v-model="form.title"></ui-input>
        <ui-select-searchable
          v-if="editMode || !packageId"
          label="Package"
          v-model="form.package"
          :error="form.errors.get('package')"
          :search="searchPackages"
          class="col-span-12"
          no-search="Type to search packages..."
        ></ui-select-searchable>
        <ui-date-picker label="Date" name="issued_date" :error="form.errors.get('issued_date')" v-model="form.issued_date"></ui-date-picker>
        <ui-textarea label="Site Address" name="site_address" :error="form.errors.get('site_address')" v-model="form.site_address"></ui-textarea>
        <ui-input label="Contract Reference" name="contract_ref" :error="form.errors.get('contract_ref')" v-model="form.contract_ref"></ui-input>
        <ui-input label="Location Of Works" name="location_of_works" :error="form.errors.get('location_of_works')" v-model="form.location_of_works"></ui-input>
        <ui-textarea label="What is the main reason or what when wrong?" name="reasoning" :error="form.errors.get('reasoning')" v-model="form.reasoning"></ui-textarea>
        <ui-textarea label="Why doesn't the work meet specs?" name="why" :error="form.errors.get('why')" v-model="form.why"></ui-textarea>
        <ui-textarea label="What can be done to prevent it from happening again?" name="prevention" :error="form.errors.get('prevention')" v-model="form.prevention"></ui-textarea>
        <ui-textarea label="Explanatory corrective action taken." name="corrective" :error="form.errors.get('corrective')" v-model="form.corrective"></ui-textarea>
        <ui-textarea label="Key players involved in the NCR and specs affected under the NCR." name="players" :error="form.errors.get('players')" v-model="form.players"></ui-textarea>
      </ui-form-section>
    </ui-container>

    <ui-container class="py-4 flex justify-end space-x-6">
      <ui-button-new v-if="editMode" @click="edit(false)">Cancel</ui-button-new>
      <ui-button-new v-else @click.prevent="form.reset()">Reset</ui-button-new>
      <ui-button-new primary @click.prevent="form.submit()" :loading="form.busy">
        {{ editMode ? 'Save' : 'Create' }}
      </ui-button-new>
    </ui-container>
  </form>
</template>

<script>
import { Ncr, Package } from '@models'

export default {
  props: {
    item: Object,
    edit: Function,
    addItem: Function,
    removeItem: Function,
    packageId: null,
  },
  data () {
    const initialData = this.item
        ? this.item.getFormAttributes()
        : {}

    return {
      form: new Form(initialData, async (form) => {
        const data = form.export()

        if (!data.package && this.packageId) {
          data.package = { value: this.packageId }
        }

        if (this.editMode) {
          await this.item.update(data)
          if (this.packageId && this.item.package_id !== parseInt(this.packageId, 10)) {
            this.removeItem(this.item)
          } else {
            this.edit(false)
          }

        } else {
          const ncr = await Ncr.create(data)
          this.addItem(ncr, 0)

          form.reset()
        }
      }),
    }
  },
  computed: {
    editMode () {
      return !! this.item
    },
  },
  methods: {
    async searchPackages (query) {
      return await Package.search(query, true)
    },
  },
}
</script>
